import React from 'react';
import styles from './css/index.module.css';

const AiWardenEvidenceCoveragePanel = ({ onSubmit, submitting }) => {
    return (
        <>
            <p className={styles.aiWardenTip}>
                Evaluate depth, completeness, reliability, and diligence-readiness of evidence in the selected scope using retrieved context only.
            </p>
            <div className={styles.aiWardenAskActions}>
                <button type="button" className={styles.aiWardenPrimaryBtn} onClick={onSubmit} disabled={submitting}>
                    {submitting ? 'Thinking…' : 'Evaluate Evidence Coverage'}
                </button>
                <span className={styles.aiWardenTip}>Output uses only retrieved context from your selection.</span>
            </div>
        </>
    );
};

export default AiWardenEvidenceCoveragePanel;
